import { observer } from 'mobx-react'
import React, { useState } from 'react'
import RenderOnQueries from '../RenderOnQueries'
import SelectionList from './SelectionList'
import TimesheetAppStore from './TimesheetAppStore'
import { processTRPCData } from '../../Queries/fetchData'
import { trpc } from '../../system/trpc'

export default observer(() => {
    return (
        <RenderOnQueries
            queryIds={[
                {
                    id: `tasks-${TimesheetAppStore.selectedPhase.id}`,
                    queryFn: async () => {
                        const requestData = await trpc.legacy.getTasks.query({
                            projectId: TimesheetAppStore.selectedProject.id,
                            phaseId: TimesheetAppStore.selectedPhase.id,
                        })
                        return processTRPCData(
                            requestData,
                            `tasks-${TimesheetAppStore.selectedPhase.id}`
                        )
                    },
                },
            ]}
        >
            <SelectionList
                title={'Task'}
                label={'name'}
                items={TimesheetAppStore.selectedPhase.tasks || []}
                backRoute={'selectPhase'}
                onChange={(task) => {
                    TimesheetAppStore.selectTask(task)
                    TimesheetAppStore.createTimeEntry()
                    TimesheetAppStore.setRoute('listEntries')
                }}
            />
        </RenderOnQueries>
    )
})
